import React, { useState } from "react";
import { X, Play } from "lucide-react";

// Lightweight YouTube video player card with click-to-play modal
export const VideoCard = ({ poster, youtubeId, videoUrl, quote, badge = "Tap to play", aspect = "aspect-[9/13]" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`group relative w-full overflow-hidden rounded-2xl ${aspect} shadow-[0_18px_50px_-20px_rgba(35,35,32,0.5)] ring-1 ring-brand-cream`}
      >
        <img src={poster} alt="client testimonial" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/70 via-brand-ink/10 to-transparent" />
        <div className="absolute left-1/2 top-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 shadow-lg transition-transform duration-300 group-hover:scale-110">
          <Play size={22} className="ml-0.5 fill-brand-sage text-brand-sage" />
        </div>
        <span className="absolute right-3 top-3 rounded-full bg-brand-ink/60 px-3 py-1 font-sans text-[10px] font-medium uppercase tracking-wider text-white backdrop-blur">
          {badge}
        </span>
        {quote && (
          <p className="absolute inset-x-0 bottom-0 p-4 text-left font-display text-lg italic leading-snug text-white">
            “{quote}”
          </p>
        )}
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-ink/80 p-4 backdrop-blur-sm animate-fade-in"
          onClick={() => setOpen(false)}
        >
          <div className="relative w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setOpen(false)}
              className="absolute -top-11 right-0 flex items-center gap-1.5 font-sans text-sm text-white/80 transition hover:text-white"
            >
              Close <X size={18} />
            </button>
            <div className="aspect-video w-full overflow-hidden rounded-2xl shadow-2xl bg-black">
              {videoUrl ? (
                <video
                  className="h-full w-full"
                  src={videoUrl}
                  poster={poster}
                  controls
                  autoPlay
                  playsInline
                />
              ) : (
                <iframe
                  className="h-full w-full"
                  src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`}
                  title="Video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
